export { default as InternalLayout } from "./InternalLayout"
